import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cfg_fiscal_period_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  parameter_name: fromDatatype.VarcharDatatypeInterface;
  parameter_type: fromDatatype.VarcharDatatypeInterface;
  parameter_value: fromDatatype.VarcharDatatypeInterface;
  parameter_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_cfg_fiscal_period_ext_RowClass implements bl_fi_cfg_fiscal_period_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  parameter_name: fromDatatype.VarcharDatatypeInterface;
  parameter_type: fromDatatype.VarcharDatatypeInterface;
  parameter_value: fromDatatype.VarcharDatatypeInterface;
  parameter_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


